export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_13.3a4d67bf.jpg";